import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import * as User from '../../helpers/User';
import * as Common from '../../helpers/Common';
import {validateFile} from '../../helpers/Fields';
import * as Config from '../../config/Config';
const $=window.$;

export default class DoyouKnow extends Component {

	 constructor(props) {


        super(props);

        this.state={
            doyou : [],
            count : 0,
            noticecount : 0,
        };

        // alert(User.UserId());

        this.getDoyouknow = this.getDoyouknow.bind(this);

    }

    getDoyouknow(){

        Common.reactLoader("show", "Please wait...");
        let learnerID = Common.getUserData("id", true);
        let productID = Common.getUserData("productID", true);
        let fullName = Common.getUserData("fullName", true);
        fetch(Config.domainUrl+'left/doyou-know', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization':'Bearer ' +Common.getTokenData()
                },

                  body: JSON.stringify({
                    learner_id:learnerID,lr_product:productID,fullName:fullName
                  })
                }).then((response) => response.json())
               .then((responseJson) => {
                Common.reactLoader("hide");
                //alert(JSON.stringify(responseJson));
                this.setState({

                    doyou : responseJson.results.completing_lr

                });


         });



    }

  

   

	componentDidMount() {
		this.getDoyouknow();
      
	}

  render() {
    let corporateID = Common.getUserData('corporateID', true);
    let doyouknow = this.state.doyou;
    const {Webview} = this.props;


    return (
            <aside className="slide-out slide2">
                {(Webview===undefined && Webview!=='webview' && corporateID!=77) && <a className="handle" href="javascript:void(0);" id="doyouk">Do you know?</a>}
                <h2><img src={'images/img1.jpg'} align="texttop" alt="" border="0"/> Do you know?</h2>
                <span dangerouslySetInnerHTML={{__html: doyouknow}}/>
            </aside>
    );
  }
}



// WEBPACK FOOTER //
// ./src/partials/qlink_partials/DoyouKnow.js